module.exports = __webpack_public_path__ + "static/media/image-crop-22-tablet.49c58d8e.jpg";